

export const environment = {
  production: false,
  tinyAPIKey:'ntgknhchci9s37en2wxm5g33q2w3c22srrdicz84xshswpkc'
};

